import { render, staticRenderFns } from "./ResultB.vue?vue&type=template&id=0b60b476&"
import script from "./ResultB.vue?vue&type=script&lang=js&"
export * from "./ResultB.vue?vue&type=script&lang=js&"
import style0 from "./ResultB.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports